import React from 'react';
import { Row, Col, FormGroup, Button } from 'react-bootstrap';
import { Label } from 'fw/components';
import { SetupSearch } from 'areas/shared/pages/setup';
import { SponsorInvoiceAuto } from 'areas/shared/controls'
import * as App from 'modules/app/App';
import DiscountCodeGenerationPopUp from '../../../admin/discountCodeSetup/discountCodeGeneration/DiscountCodeGenerationPopUp'; // TODO: Review this import

class Search extends SetupSearch {

    initialForm() {
        return {
            paypalInvoiceId: null,
			paypalInvoiceNumber: null,
			sponsorId: this.props.searchProps.sponsorId,
			addPrivilege: App.hasPrivilege("AdminDiscountCodeSetupGenerate")
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

	handleSponsorInvoiceIdChange = (invoice) => {
		this.setState((prevState) => {
			return ({
				form: {
					...prevState.form,
					paypalInvoiceId: invoice != null ? invoice.value : null,
					paypalInvoiceNumber: invoice != null ? invoice.label : null
				}
			});
		}, () => { this.search(); });
    }

	onGenerateDiscountCodePopUpClose = (success) => {
        this.setState({
            showGenerateDiscountCodePopUp: false
        }, () => { if (success === true) { this.search() } });
    }

    onGenerateDiscountCodeClick = () => {
        this.setState({
            showGenerateDiscountCodePopUp: true
        });
    }

    renderForm() {
        return (
            <Row>
                <Col md={2}>
					<FormGroup>
						<Label>Invoice Number</Label>
						<SponsorInvoiceAuto
							name="paypalInvoiceId"
							placeholder='Search Invoice...'
							preloadMonths={24}
							sponsorId={this.props.searchProps.sponsorId}
							value={this.state.form.paypalInvoiceId}
							text={this.state.form.paypalInvoiceNumber}
							onChange={(invoice) => this.handleSponsorInvoiceIdChange(invoice)}
							formControl={false} />
					</FormGroup>
                </Col>
				{this.state.form.addPrivilege ?
                    <Col md={10} style={{paddingRight:"5px"}}>
                        <Button style={{marginTop:"-55px"}} id='btnGenerateDiscountCodePopUp' onClick={this.onGenerateDiscountCodeClick} bsClass="btn btn-success" className="pull-right">
                            Generate Discount Code
                        </Button>
                        {<DiscountCodeGenerationPopUp
                            visible={this.state.showGenerateDiscountCodePopUp}
                            onClose={this.onGenerateDiscountCodePopUpClose}
							sponsorId={this.props.searchProps.sponsorId}
							sponsorName={this.props.searchProps.sponsorName}
                        />}
                    </Col>
                :null }
            </Row>
        )
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/areas/admin/sponsorSetup/discountCodesHistory/Search.js